import { Container, CssBaseline, Grid } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom';
import MyBreadcrumbs from '../../../../components/MyBreadcrumbs';

const breadcrumbItem = { '/admin': 'Home', '/admin/bendahara': 'Bendahara' };

const Bendahara = () => {
    return (
        <>
            <CssBaseline />
            <MyBreadcrumbs breadcrumbItem={breadcrumbItem} title="ADMIN" />
            <Container sx={{ my: 3 }} maxWidth="xxl">
                <Grid container spacing={2} direction="row"
                    justifyContent="center"
                >
                    <Grid item xs={12} md={12}>
                        <Outlet />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}

export default Bendahara